export function createMixpanelWrapper(mixpanel, options) {
  return new Proxy(mixpanel, {
    get(target, propertyName) {
      const originalMethod = Reflect.get(target, propertyName);
      const isMethod = typeof originalMethod === "function";
      if (isMethod && (options.disable || import.meta.server)) {
        return (...args) => {
          if (!options.config.debug || import.meta.server) {
            return;
          }
          console.info(`Mixpanel is disabled, "${propertyName}" method has not been called.`);
          console.info(
            `${propertyName}(${args.filter(Boolean).map((arg) => JSON.stringify(arg)).join(", ")})`
          );
        };
      }
      return originalMethod;
    }
  });
}
